export const SETTINGS = {
    FETCH_ALL_CULTURES : "FETCH_ALL_CULTURES",
    CREATE_CULTURE : "CREATE_CULTURE",
    BULK_UPLOAD : "BULK_UPLOAD",
    DELETE_CULTURE : "DELETE_CULTURE",
    GET_RESOURCE : "GET_RESOURCE"
}